export default "__VITE_ASSET__yOJsbWBC__"